import {
    IProduceBackupInjectable,
} from '@src/slide/application/service/produce-backup-manager/inject/produce-backup-injectable.interface';
import { isEditableDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import i18n from '@i18next/i18n';
import { IAidOptions } from '@src/js/common/ark-extensions/dc-components/docs-component-size-limit-dialog';
import { copyDoc, copyDrive } from '@src/js/common/ark-extensions/dc-components/copy';

export default class ProduceBackupInjectable implements IProduceBackupInjectable {
    public getCreateDocNewErrorToastInfo(res, licenseErrMsg?, commonErrMsg?): { msg: string; type: string } {
        return {
            msg: commonErrMsg || i18n.t('生成副本失败，请稍后重试'),
            type: 'error',
        };
    }

    public produceBackup(aidOptions?: IAidOptions): void {
        if (isEditableDriveFile()) {
            copyDrive({ from: aidOptions?.aidPosition });
        } else {
            copyDoc({ shouldCheckVip: this.shouldCheckVipStatus(), aidFrom: aidOptions?.aidPosition });
        }
    }

    /**
     * 是否检查vip状态
     */
    public shouldCheckVipStatus(): boolean {
        return true;
    }
}
